import { deleteData, getData, postData } from "./axiosConfig"

export const updateProfile = async (body) => {
    return await postData("user/profile-update", body)
}

export const updatePassword = async (body) => {
    return await postData("user/change-password", body)
}

export const addAddress = async (body) => {
    return await postData("user/address/store", body)
}

export const getAddress = async () => {
    return await getData("user/address")
}

export const updateAddress = async (body) => {
    return await postData("user/address/update", body)
}

export const deleteAddress = async (id) => {
    return await postData("user/address/delete", id)
}

export const getOrders = async () => {
    return await getData("user/order/get-all")
}



export const getCard = async () => {
    return await getData("user/get-user-cards")
}

export const addUserCard = async (body) => {
    return await postData("user/save-user-card", body)
}

export const deleteCard = async (id) => {
    return await getData(`user/delete-user-card/${id}`)
}

export const updateCard = async (id, body) => {
    return await postData(`user/save-user-card/${id}`, body)
}